<mat-card class="example-card"> 
  <mat-card-content>
    <mat-toolbar color="primary">Modèle de caractéristiques</mat-toolbar>
    <ng-template #attente>
            <br>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
        <div *ngIf="enregistrementTerminer;else attente"></div>
    <br>    
    <form class="example-form" #f="ngForm">
        <div fxLayout="row">
            <mat-form-field style="margin-right: 10px" class="example-full-width">
                <input matInput [disabled]="disabled" name="ecArtCarMod_Label"
                    #ecArtCarMod_Label="ngModel" [(ngModel)]="caracteristiqueModel.ecArtCarMod_Label"
                    placeholder="Désignation modèle" required>
            </mat-form-field>      
            <div class="button-row">
                <button type="submit" (click)="ajouter(f)" [disabled]="disabled" class="bet_time" mat-raised-button color="primary">Ajouter</button>
            </div>
        </div>    
    </form>          
    
    <div fxLayout="row" fxLayoutAlign="space-between none" >
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </mat-form-field>
        <div fxLayout="row">                                  
            <div  style="margin-right: 20px" class="button-row">
            <button (click)="modifier()" mat-raised-button class="colorGreen">Modifier</button>
            </div>
            
            <div  style="margin-right: 20px"  class="button-row">
            <button [disabled]="disabledBtnSupprimer" (click)="supprimer()" mat-raised-button class="colorReed">Supprimer</button>
            </div>         
        </div>
    </div>
    <div class="example-table-container">
      <table id="tablecaracteristiques" mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="ecArtCarMod_Id">
            <th mat-header-cell *matHeaderCellDef> Code </th>
            <td mat-cell *matCellDef="let element"> {{element.ecArtCarMod_Id}} </td>
        </ng-container>
        <ng-container matColumnDef="ecArtCarMod_Label">
            <th mat-header-cell *matHeaderCellDef> Texte </th>
            <td mat-cell *matCellDef="let element"> 
                <mat-form-field style="margin-right: 10px" class="example-full-width">
                    <input matInput [disabled]="disabled" [name]="'caracteristiqueText2'+element.ecArtCarMod_Id"
                        #ecArtCarMod_Label="ngModel" [(ngModel)]="element.ecArtCarMod_Label"
                        >
                </mat-form-field>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow($event,row)"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>